module.exports = __webpack_public_path__ + "static/media/lateralhead_severe_left.d6b8c532.png";